import { render, staticRenderFns } from "./mainPicture.vue?vue&type=template&id=70ee3fc0&scoped=true&"
import script from "./mainPicture.vue?vue&type=script&lang=ts&"
export * from "./mainPicture.vue?vue&type=script&lang=ts&"
import style0 from "./mainPicture.vue?vue&type=style&index=0&id=70ee3fc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee3fc0",
  null
  
)

export default component.exports